<!-- 
Dialog for running a levy collection task.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>
          <v-icon v-if="task.type" class="mr-2">{{ getIcon(task.type) }}</v-icon>
          {{ lookups.levyCollectionTaskTypeDescriptions[task.type] }}
        </v-toolbar-title>
        <v-spacer/>
        <our-user-guide-button topic="levy-collection-workflow" section="running-a-levy-collection-task"/>
      </v-toolbar>
      <our-busy-indicator :show="state.processing"/>
      <v-card-text>
        <p>{{ task.description }}</p>
        <p v-if="longRunning" class="font-weight-medium">
          This can take a couple of minutes to complete.
        </p>
        <div v-if="hasPreview">
          <div v-if="previewLoading">
            <v-progress-circular
              v-if="previewLoading"
              indeterminate
              color="primary"
            />
            <span class="ml-3 grey--text text--darken-1">Loading...</span>
          </div>
          <task-import-in-scope-providers-preview 
            v-if="task.type == 'ImportInScopeProviders'"
            :task="task" :levy-collection-id="levyCollectionId" :show="show" 
            @loaded="previewLoading=false"
          />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="state.processing" flat @click="hide">Cancel</v-btn>
        <v-btn :disabled="state.processing" flat color="success" @click="run">
          {{ lookups.levyCollectionTaskTypeDescriptions[task.type] }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <our-validation-dialog v-model="showValidationDialog" :state-error="state.error" />
  </v-dialog>
</template>

<script>
import _ from "underscore";
import * as action from "@/store/levy-collections/action-types";
import lookupMixins from "@/mixins/lookup.mixins";
import TaskImportInScopeProvidersPreview from "@/components/levy-collections/TaskImportInScopeProvidersPreview.vue";
import taskMixins from "@/mixins/task.mixins";

export default {
  components: { TaskImportInScopeProvidersPreview },
  mixins: [lookupMixins, taskMixins],
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    levyCollectionId: {
      type: Number,
      default: null
    },
    task: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      previewLoading: true,
      showValidationDialog: false
    };
  },
  computed: {
    state() {
      return this.$store.state.levyCollections.task;
    },
    hasPreview() {
      return this.task.type == "ImportInScopeProviders";
    },
    longRunning() {
      const task = _.find(this.lookups.levyCollectionTaskTypes, t => t.value == this.task.type);
      return task && task.attributes && task.attributes.includes("LongRunning");
    }
  },
  watch: {
    async show(nowShowing) {
      if (nowShowing) {
        this.previewLoading = true;
      }
    }
  },
  methods: {
    async run() {
      if (this.task.type == "Delete") {
        this.$router.push(`/levy-collections/${this.levyCollectionId}/delete`);
      } else {
        const data = {
          levyCollectionId: this.levyCollectionId,
          type: this.task.type,
          description: this.lookups.levyCollectionTaskTypeDescriptions[this.task.type]
        };
        const successful = await this.$store.dispatch(action.TASK_RUN, data);
        this.hide();
        this.showValidationDialog = !successful;
      }
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
